"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUploadAssetUrlResponseToJSON = exports.GetUploadAssetUrlResponseFromJSONTyped = exports.GetUploadAssetUrlResponseFromJSON = void 0;
function GetUploadAssetUrlResponseFromJSON(json) {
    return GetUploadAssetUrlResponseFromJSONTyped(json, false);
}
exports.GetUploadAssetUrlResponseFromJSON = GetUploadAssetUrlResponseFromJSON;
function GetUploadAssetUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': json['url'],
        'fileName': json['fileName'],
    };
}
exports.GetUploadAssetUrlResponseFromJSONTyped = GetUploadAssetUrlResponseFromJSONTyped;
function GetUploadAssetUrlResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
        'fileName': value.fileName,
    };
}
exports.GetUploadAssetUrlResponseToJSON = GetUploadAssetUrlResponseToJSON;
